import React from "react";
import Grid from "@mui/material/Grid";
import LogoImage from "../../images/sbb-logo-white.svg";
import {Link} from "react-router-dom";
import Btn from "@mui/material/Button/Button";
import variables from './../../css/theme.module.scss';
import styled from "@emotion/styled";
import useClasses from "../../utils/themeUtils";
import {useNavigate} from "react-router";

const SBButton = styled(Link)({
    color: 'white',
    textDecoration: 'none',
    '& .MuiButton-root':{
        fontFamily: variables.Avenir,
        letterSpacing: 0
    }
});

export default function AuthMenuComponent({type}) {
    const navigate = useNavigate();

    const useStyles = theme => ({
        root: {
            flexGrow: 1,
        },
        loginForm: {
            flexGrow: 1,
            height: 'calc(100vh - 170px)',
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        title: {
            flexGrow: 1,
        },
        navStyle: {
            color: 'white',
            textDecoration: 'none',
            '& .MuiButton-label':{
                fontFamily: variables.Avenir,
                letterSpacing: 0
            }
        },
    });

    const classes = useClasses(useStyles);

    const goHome = () => {
        navigate('/')
    };

    return (
        <Grid container className={classes.root} spacing={0}>
            <Grid container
                  sx={{p:'10px'}}
                  item
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  xs={12} spacing={0} sm={12} md={3} lg={3}>
                    <img width="200px" height="40px" className="hover" onClick={goHome} src={LogoImage}/>
            </Grid>

            <Grid container
                  item
                  display={{ xs: "none", sm: "none", md: "flex" }}
                  spacing={0} md={2} lg={2} xl={2}/>

            <Grid container
                  item
                  xs={12} spacing={0} sm md lg
                  justifyContent="end"
                  alignItems="center">
                <SBButton to='/login'>
                    <Btn color="inherit">Login</Btn>
                </SBButton>
                { type !== 'brands' &&
                    <SBButton to={'/get-started'}>
                        <Btn color="inherit">Get Started</Btn>
                    </SBButton>
                }
            </Grid>
        </Grid>
    );
}
